import { useContext, useEffect, useRef, useState } from "react";
import { BaseModal } from "../../../../components/modal";
import { Context } from "../../../../context";
import { PayslipDetailsModalWrapper } from "./styled";
import { Column, Row } from "../../../../components/flex/styled";
import { Table } from "../../../../components/table";
import { H3, P, Span } from "../../../../components/typography/styled";
import { getEmployeePayslipDetails } from "../../../../utils/apis/payroll/getEmployeePayslipDetails";
import Cookies from "universal-cookie";
import { BaseButton } from "../../../../components/button/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import defaultLogo from "../../../../assets/images/profilebasefavicon.svg";
import logoSvg from "../../../../assets/workplace-pay-logo-only.svg";
export const PayslipDetailsModal = ({ height, width, payslipId }) => {
  const cookies = new Cookies();
  const TOKEN = cookies.get("TOKEN");

  const { isPayslipDetailsModalOpen, setIsPayslipDetailsModalOpen } =
    useContext(Context);

  const [matches, setMatches] = useState(false);
  const [payslipDetail, setPayslipDetail] = useState({});
  const componentRef = useRef(null);

  const handleCloseModal = () => {
    document.body.style.overflow = "auto";
    document.body.style.pointerEvents = "auto";
    setIsPayslipDetailsModalOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setMatches(window.screen.availWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!payslipId) return;
    const retrievePayslip = async () => {
      try {
        const payslip = await getEmployeePayslipDetails(TOKEN, payslipId);
        setPayslipDetail(payslip?.data);
      } catch (error) {
        console.error("Failed to fetch employee payslip:", error);
      }
    };
    retrievePayslip();
  }, [TOKEN, payslipId]);

  const formatDate = (raw) => {
    if (!raw) return "";
    const d = new Date(raw);
    if (isNaN(d.getTime())) return raw;
    return new Intl.DateTimeFormat("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    }).format(d);
  };

  const handlePrint = () => {
    const printContent = componentRef.current;
    if (!printContent) return;

    const printWindow = window.open("", "", "width=900,height=1000");

    const styles = Array.from(
      document.querySelectorAll('link[rel="stylesheet"], style, [data-styled]'),
    )
      .map((node) => node.outerHTML)
      .join("\n");

    const rootStyles = getComputedStyle(document.documentElement);
    const cssVars = Array.from(rootStyles)
      .filter((prop) => prop.startsWith("--"))
      .map((prop) => `${prop}: ${rootStyles.getPropertyValue(prop)};`)
      .join("\n");

    printWindow.document.write(`
    <html>
      <head>
        <title>Employee Payslip - ${payslipDetail.fullName || "Payslip"}</title>
        ${styles}
        <style>
          :root { ${cssVars} }

          body {
            background: var(--color-background);
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
                         'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
                         'Helvetica Neue', sans-serif;
            margin: 0;
            padding: 10px;
          }

          .print-wrapper {
            position: relative;
            z-index: 1;
            width: 100%;
            max-width: 100%;
            margin: auto;
            box-sizing: border-box;
          }  

          /* Ensure backgrounds are transparent so the watermark can bleed through */
          .print-wrapper, .print-wrapper > div, table, tbody, tr, td {
            background-color: transparent !important;
          }

          .print-watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 60%;
            max-width: 400px;
            opacity: 0.06;
            pointer-events: none;
            z-index: 0;
          }

            .employee-information-block {
               margin-bottom: 1rem; 
            }

            .user-summary-table:first-of-type {
              margin-top: 1rem; 
             }
              

          /* Force Row/Column to behave like flex containers */
          [class*="Row"], [class*="row"], [class*="employee-information"],
          [class*="Column"], [class*="column"], [class*="employee-information-block"] {
            display: flex !important;
          }

          [class*="Row"], [class*="row"], [class*="employee-information"] {
            flex-direction: row !important;
            gap: 0.7rem !important; /* small gap between elements */
          }

          [class*="Column"], [class*="column"], [class*="employee-information-block"] {
            flex-direction: column !important;
            gap: 0.25rem !important; /* small gap between rows */
          }

          [class*="Row"] > div, [class*="row"] > div {
            margin-right: 0.5rem; /* fallback spacing */
          }

          /* Moderate breathing room between tables and footers for print */
          .user-summary-table {
            margin-bottom: 15px !important;
          }
          
          .table-footer {
            margin-top: 5px !important;
            padding: 5px 10px !important;
            justify-content: space-between !important;
          }
          
          .net-payable-summary {
            margin-top: 15px !important;
          }

          .table-footer-title h3, .table-footer-value h3 {
            min-width: auto !important;
            padding-inline-start: 0 !important;
          }
          
          .employee-information-block {
             margin-bottom: 15px !important; 
        }
           
        .net-payable-description {
           padding-left: 12px !important; 
        }
       .net-payable-amount {
         padding: 8px 12px !important; 
         margin: 0 !important;        
        }

          /* Hide interactive elements */
          .close-modal-button,
          .close-modal-button-area,
          .button-div {
            display: none !important;
          }

          @media print {
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            @page {
              size: A4 portrait;
              margin: 1cm;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-wrapper">
          ${printContent.outerHTML}
        </div>
        <img src="${logoSvg}" class="print-watermark" alt="watermark" />
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 700);
  };

  return (
    <BaseModal
      open={isPayslipDetailsModalOpen}
      onClose={handleCloseModal}
      className={"payslip-details-modal"}
      height={matches ? "auto" : height || "auto"}
      width={matches ? "auto" : width || "50%"}
    >
      <PayslipDetailsModalWrapper>
        <Row
          className="close-modal-button-header"
          justifycontent={"space-between"}
        >
          <div className="close-modal-button-area">
            <BaseButton
              className="close-modal-button"
              onClick={handleCloseModal}
            >
              <Span>
                <FontAwesomeIcon icon={faXmark} color="#FFFFFF" />
              </Span>
            </BaseButton>
          </div>
          <div className="summary-button">
            <BaseButton
              onClick={handlePrint}
              type="button"
              backgroundcolor={"var(--color-primary)"}
              width={matches ? "-webkit-fill-available" : "fit-content"}
            >
              Download Payslip
            </BaseButton>
          </div>
        </Row>
        <div ref={componentRef}>
          <div
            className="heading-row"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <img
                src={
                  payslipDetail?.companyLogo ||
                  payslipDetail?.companyLogoImageUrl ||
                  defaultLogo
                }
                alt="Company Logo"
                style={{
                  height: "60px",
                  width: "60px",
                  objectFit: "cover",
                  borderRadius: "50%",
                  border: "1px solid var(--color-primary-hover)",
                }}
              />
              <h2 style={{ margin: 0, fontWeight: 600 }}>
                {payslipDetail?.companyName}
              </h2>
            </div>
            <div style={{ textAlign: "right" }}>
              <span
                style={{
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  color: "var(--color-primary)",
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                DATE GENERATED
              </span>
              <p
                style={{
                  margin: 0,
                  fontSize: "0.95rem",
                  color: "#555",
                  fontWeight: 500,
                }}
              >
                {formatDate(payslipDetail.datePaid)}
              </p>
            </div>
          </div>
          <Column className="employee-information-block">
            <Row className="employee-information">
              <div>
                <Span>Employee Name:</Span>
              </div>
              <div>
                <Span>{payslipDetail.fullName}</Span>
              </div>
            </Row>
            <Row className="employee-information">
              <div>
                <Span>Designation:</Span>
              </div>
              <div>
                <Span>{payslipDetail.department}</Span>
              </div>
            </Row>
          </Column>
          <div className="user-summary-table">
            <Table
              location={"User Summary Table"}
              columnTitles={["Earnings", "Amount"]}
              rowItems={payslipDetail.earnings ?? []}
            />
            <Row
              gap={"0"}
              justifycontent={"space-between"}
              className="table-footer"
            >
              <div className="table-footer-title">
                <H3>Gross Earning</H3>
              </div>
              <div className="table-footer-value">
                <H3>{payslipDetail?.totalEarnings?.toLocaleString()}</H3>
              </div>
            </Row>
          </div>
          <div className="user-summary-table">
            <Table
              location={"User Summary Table"}
              columnTitles={["Deductions", "Amount"]}
              rowItems={(payslipDetail.deductions ?? []).map((deduction) => ({
                ...deduction,
                name:
                  deduction.name?.toLowerCase() === "paye"
                    ? "PAYE"
                    : deduction.name,
              }))}
            />
            <Row
              gap={"0"}
              justifycontent={"space-between"}
              className="table-footer"
            >
              <div className="table-footer-title">
                <H3>Total Deduction</H3>
              </div>
              <div className="table-footer-value">
                <H3>{payslipDetail?.totalDeductions?.toLocaleString()}</H3>
              </div>
            </Row>
          </div>
          <div className="net-payable-summary">
            <Row
              justifycontent={"space-between"}
              className="net-payable-summary-row"
            >
              <div className="net-payable-description">
                <H3>TOTAL NET PAYABLE</H3>
                <P>Gross Earning - Total Deduction</P>
              </div>
              <div className="net-payable-amount">
                <H3>{payslipDetail?.netSalary?.toLocaleString()}</H3>
              </div>
            </Row>
          </div>
        </div>
      </PayslipDetailsModalWrapper>
    </BaseModal>
  );
};
